// move inside to body to have more perf
document.addEventListener("DOMContentLoaded", function () {
  const loader = document.getElementById("loader");
  if (loader) {
    loader.style.display = "flex";
  }

  document.body.classList.remove("page-transition");
  document.body.classList.add("loading");
  document.body.classList.remove("loaded");
});

window.addEventListener("load", function () {
  const loader = document.getElementById("loader");
  if (loader) {
    loader.style.display = "none";
  }

  document.body.classList.remove("loading");
  document.body.classList.add("loaded");
});
